import styled from 'styled-components';

export const CertificatesContainer = styled.section`
  margin: 10px 0 10px 4px;
  display: flex;
  align-items: center;
  column-gap: 9px;
  justify-content: center;

  @media (max-width: 720px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const CertificatesDiv = styled.div`
  flex-shrink: 0;
  flex-basis: 20%;
  display: flex;
  align-items: center;
  column-gap: 4px;
  border-right: 1px solid hsl(0deg, 0%, 0%, 24%);
  padding-right: 10px;
  justify-content: center;
  @media (max-width: 720px) {
    // flex-basis: 40%;
    min-width: 48%;
    max-height: 20px;
    margin-top: 20px;
    justify-content: flex-start;
  }

  &:nth-last-child(1) {
    border-right: none;
  }

  &:nth-child(even) {
    @media (max-width: 720px) {
      border-right: none;
    }
  }
`;

export const CertificateImageContainer = styled.div`
  height: 32px;
  width: 32px;
  position: relative;
`;
export const CertificatesName = styled.span`
  font-size: clamp(11px, 2vw, 15px);
  color: hsl(0deg, 0%, 0%, 80%);
  font-weight: 500;
  white-space: nowrap;
`;

export const DesktopShow = styled.div`
  @media (max-width: 720px) {
    display: none;
  }
`;

export const MobileShow = styled.div`
  display: none;
  @media (max-width: 720px) {
    display: block;
  }
`;
